import { Button } from '@dev-spendesk/grapes';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'common/hooks/useTranslation';
import { PaymentContext } from 'modules/invoices/hooks';

import { useConfirmTransfersTrackingEvents } from '../../../hooks';
import { selectors, actions, useSelectorWithContext } from '../../../redux';
import { TransferCancelModal } from '../../TransferCancelModal';

export const CancelTransfersButton = () => {
  const { t } = useTranslation('global');
  const { type } = PaymentContext.useContext();
  const confirmTransfersTrackingEvents = useConfirmTransfersTrackingEvents();

  const transfersSelected = useSelectorWithContext(
    selectors.selectTransfersSelected,
  );
  const transfersSelectedCount = useSelectorWithContext(
    selectors.selectTransfersSelectedCount,
  );

  const [isCancelTransfersModalOpen, setIsCancelTransfersModalOpen] =
    useState<boolean>(false);
  const openCancelTransfersModal = () => {
    setIsCancelTransfersModalOpen(true);
    confirmTransfersTrackingEvents.onConfirmTransfersRejectionModalOpened({
      transfers: transfersSelected,
    });
  };
  const closeCancelTransfersModal = () => {
    setIsCancelTransfersModalOpen(false);
    confirmTransfersTrackingEvents.onConfirmTransfersRejectionModalClosed({
      transfers: transfersSelected,
    });
  };

  const dispatch = useDispatch();

  const resetTransfersSelection = () => {
    dispatch(actions.resetTransfersSelection({ type }));
  };

  return (
    <>
      <Button
        text={t('invoices.transfer.actions.cancelTransfer', {
          count: transfersSelectedCount,
        })}
        fit="parent"
        variant="secondaryAlert"
        isDisabled={transfersSelectedCount === 0}
        onClick={openCancelTransfersModal}
      />
      <TransferCancelModal
        transfers={transfersSelected}
        isOpen={isCancelTransfersModalOpen}
        onClose={closeCancelTransfersModal}
        onConfirm={resetTransfersSelection}
      />
    </>
  );
};
